import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { postNotification } from '../api/api';

const changeUnseenNotificationState = async (ids: string[]): Promise<void> => {
  return postNotification(`${API_URLS_ENTITY.NOTIFICATIONS.NOTIFICATION_FEED}`, { ids });
};

export const useChangeUnseenNotifications = (): UseMutationResult<
  void,
  AxiosError<{ message?: string; type?: string }>,
  { ids: string[] }
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: ({ ids }) => changeUnseenNotificationState(ids),
    onMutate: () => {
      setIsLoading(true);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
